import React, { useState } from "react";
import {
	Container,
	Grid,
	Paper,
	Button,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	TextField,
	Typography,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import axios from "axios";
import { withSnackbar } from "notistack";

// Define the mapping between display values and constants
const liveOpsTypeMappings = {
	"CosmeticBundle (Animated)": "COSMETIC_BUNDLE_ANIMATED",
	"CosmeticBundle (Normal)": "COSMETIC_BUNDLE_NORMAL",
	MarketingBanner: "MARKETING_BANNER",
	None: "None",
};

// The display options for the dropdown
const liveOpsTypes = [
	"None",
	"CosmeticBundle (Animated)",
	"CosmeticBundle (Normal)",
	"MarketingBanner",
];

const useStyles = (theme) => ({
	root: {
		display: "flex",
	},
	container: {
		paddingTop: theme.spacing(4),
		paddingBottom: theme.spacing(4),
	},
	paper: {
		padding: theme.spacing(2),
		display: "flex",
		overflow: "auto",
		flexDirection: "column",
	},
	formControl: {
		minWidth: 120,
		marginRight: theme.spacing(2),
	},
	button: {
		marginTop: theme.spacing(2),
	},
	indicator: {
		color: "green",
		fontWeight: "bold",
		marginTop: theme.spacing(1),
	},
});

const LiveOpsView = ({ classes, dev, enqueueSnackbar }) => {
	const [LiveOpsData, setLiveOpsData] = React.useState({
		id: "",
		type: "None",
	});

	const handleInputChange = (event) => {
		const { id, value } = event.target;
		console.log(id, value);
		if (id === "LiveOpsID") {
			setLiveOpsData((prevEventData) => ({
				...prevEventData,
				id: value,
			}));
		} else {
			setLiveOpsData((prevEventData) => ({
				...prevEventData,
				type: value,
			}));
		}
	};

	const deployEvent = () => {
		// Get the mapped value for the selected liveOpsType
		const liveOpsTypeConstant = liveOpsTypeMappings[LiveOpsData.type];

		axios
			.post("/api/dev/" + dev + "/deployLiveOps", {
				id: LiveOpsData.id,
				type: liveOpsTypeConstant, // Use the mapped constant value
			})
			.then((json) => json.data)
			.then((data) => {
				if (data.err) {
					throw new Error(data.err);
				}
				enqueueSnackbar("Done.", {
					variant: "success",
				});
			})
			.catch((err) => {
				enqueueSnackbar("Something went wrong. " + err, {
					variant: "error",
				});
			});
	};

	return (
		<Container maxWidth="lg" className={classes.container}>
			<Grid container spacing={3}>
				<Grid item xs={12} sm={6}>
					<Paper className={classes.paper}>
						<FormControl variant="outlined" className={classes.formControl}>
							<InputLabel id="select-id">LiveOps Type</InputLabel>
							<Select
								labelId="select-id"
								id="liveopsType"
								value={LiveOpsData.type}
								onChange={handleInputChange}
								label="LiveOps Type"
							>
								{liveOpsTypes.map((optionText, index) => (
									<MenuItem key={index} value={optionText}>
										{optionText}
									</MenuItem>
								))}
							</Select>
						</FormControl>
					</Paper>
				</Grid>
				<Grid item xs={12} sm={6}>
					<Paper className={classes.paper}>
						<TextField
							id="LiveOpsID"
							label="LiveOps ID"
							variant="outlined"
							value={LiveOpsData.id}
							onChange={handleInputChange}
						/>
					</Paper>
				</Grid>
				<Grid item xs={12}>
					<Button
						className={classes.button}
						variant="contained"
						color="primary"
						disabled={LiveOpsData.type === "None"}
						onClick={deployEvent}
					>
						Deploy
					</Button>
					{LiveOpsData.type === "None" ? (
						<Typography variant="body2" className={classes.indicator}>
							*Please select a LiveOps type at least.
						</Typography>
					) : null}
				</Grid>
			</Grid>
		</Container>
	);
};

export default withStyles(useStyles)(withSnackbar(LiveOpsView));
